import { render, staticRenderFns } from "./GenerateLedger.vue?vue&type=template&id=1545eb74"
import script from "./GenerateLedger.vue?vue&type=script&lang=js"
export * from "./GenerateLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports